import { makeStyles } from "@material-ui/core/styles";

const useStyles = makeStyles((theme) => ({
  container: {
    marginTop: 10,
  },
  historyWrapper: {
    maxHeight: 220,
    overflowY: "auto",
    border: "1px solid #ddd",
    borderRadius: 4,
    padding: 0,
    marginTop: 10,
  },
  list: {
    padding: 0,
    margin: 0,
    listStyle: "none",
    direction: "rtl",
  },
  listItem: {
    padding: 8,
    borderBottom: "1px solid #eee",
  },
  actionLabel: {
    display: "inline-block",
    padding: "2px 4px",
    borderRadius: 4,
  },
}));

export default useStyles;
